import {
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
} from '../../../../Constants/actionTypes';

import { updateUserApi } from '../../../../Constants/apiService';

export const updateUserRequest = () => ({ type: UPDATE_USER_REQUEST });
export const updateUserSuccess = (data) => ({ type: UPDATE_USER_SUCCESS, payload: data });
export const updateUserFailure = (error) => ({ type: UPDATE_USER_FAILURE, payload: error });

export const updateUserAct = (payload) => {
  return async (dispatch, getState) => {
    dispatch(updateUserRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await updateUserApi(payload, accessToken);
      dispatch(updateUserSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(updateUserFailure(errorMessage));
      return null;
    }
  };
};
